import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Hethanphuhieu from "components/Canhbao/Hethanphuhieu.js";
import Hethangiayphepkdvt from "components/Canhbao/Hethangiayphepkdvt.js";
import Canhbaoxehopdong from "components/Canhbao/Canhbaoxehopdong.js";
export default function XNhopdong() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Cảnh báo hết hạn phù hiệu",
            tabContent: <Hethanphuhieu />,
          },
          {
            tabName: "Cảnh báo hết hạn giấy phép KDVT",
            tabContent: <Hethangiayphepkdvt />,
          },
          {
            tabName: "Cảnh báo xe hợp đồng",
            tabContent: <Canhbaoxehopdong />,
          },
        ]}
      />
    </div>
  );
}
